import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getCustomGeoZones(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONES,
		options
	)
}

function _getCustomGeoZonePreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONE_PREVIEW,
		options
	)
}

function _getCustomGeoZonePopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONE_POPUP,
		options
	)
}

function _createCustomGeoZone(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].CREATE_CUSTOM_GEO_ZONE,
		options
	)
}

function _getCustomGeoZone(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONE,
		options
	)
}

function _patchCustomGeoZone(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].PATCH_CUSTOM_GEO_ZONE,
		options
	)
}

function _putCustomGeoZone(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].PUT_CUSTOM_GEO_ZONE,
		options
	)
}

function _deleteCustomGeoZone(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].DELETE_CUSTOM_GEO_ZONE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONES]: _getCustomGeoZones,
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONE]: _getCustomGeoZone,
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONE_POPUP]: _getCustomGeoZonePopup,
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONE_PREVIEW]: _getCustomGeoZonePreview,
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].CREATE_CUSTOM_GEO_ZONE]: _createCustomGeoZone,
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].PUT_CUSTOM_GEO_ZONE]: _putCustomGeoZone,
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].PATCH_CUSTOM_GEO_ZONE]: _patchCustomGeoZone,
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].DELETE_CUSTOM_GEO_ZONE]: _deleteCustomGeoZone
}
